import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TranslateDialogViewModel from "./../factories/translate-dialog";
function ConfigurationItemDiaryCategoryViewModel(tabPage) {
    var self = this;
    self.Category1 = ko.observable();
    self.Category2 = ko.observable();
    self.Category3 = ko.observable();
    self.Category4 = ko.observable();
    self.Category5 = ko.observable();
    self.Category = ko.pureComputed({
        read: function () {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return self.Category1();
                case 2:
                    return self.Category2();
                case 3:
                    return self.Category3();
                case 4:
                    return self.Category4();
                case 5:
                    return self.Category5();
            }
        },
        write: function (value) {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    self.Category1(value);
                    break;
                case 2:
                    self.Category2(value);
                    break;
                case 3:
                    self.Category3(value);
                    break;
                case 4:
                    self.Category4(value);
                    break;
                case 5:
                    self.Category5(value);
                    break;
            }
        }
    });
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Category())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.TranslateCategory = function () {
        let translateDialog = new TranslateDialogViewModel(self.Category1, self.Category2, self.Category3, self.Category4, self.Category5);
        translateDialog.Open().then(function () {
        });
    };
}
Bao.inherit(ConfigurationItemDiaryCategoryViewModel, SearchPaging);
ConfigurationItemDiaryCategoryViewModel.prototype.PrimaryKey = "ConfigurationItemDiaryCategoryId";
ConfigurationItemDiaryCategoryViewModel.prototype.RefreshUrl = "ConfigurationItemDiaryCategory/Get";
ConfigurationItemDiaryCategoryViewModel.prototype.SaveUrl = "ConfigurationItemDiaryCategory/Save";
ConfigurationItemDiaryCategoryViewModel.prototype.DeleteUrl = "ConfigurationItemDiaryCategory/Delete";
ConfigurationItemDiaryCategoryViewModel.prototype.IsInUseUrl = "ConfigurationItemDiaryCategory/IsInUse";
ConfigurationItemDiaryCategoryViewModel.prototype.PermissionForward = "ConfigurationItemDiaryCategoryMoveForwardSearch";
ConfigurationItemDiaryCategoryViewModel.prototype.PermissionBackward = "ConfigurationItemDiaryCategoryMoveBackwardSearch";
ConfigurationItemDiaryCategoryViewModel.prototype.PermissionSave = "ConfigurationItemDiaryCategorySave";
ConfigurationItemDiaryCategoryViewModel.prototype.PermissionRefresh = "ConfigurationItemDiaryCategoryRefresh";
ConfigurationItemDiaryCategoryViewModel.prototype.PermissionDelete = "ConfigurationItemDiaryCategoryDelete";
export default ConfigurationItemDiaryCategoryViewModel;